/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const LoginIcon = ({ className }) => (
  <svg
    width="16px"
    height="18px"
    viewBox="0 0 22 24"
    version="1.1"
    className={className}
  >
    <g
      id="navigation"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="FRE-030-XS_header_big"
        transform="translate(-45.000000, -188.000000)"
        stroke="currentColor"
        strokeWidth="2.5"
      >
        <g id="login" transform="translate(0.000000, 173.000000)">
          <g id="Group-4" transform="translate(47.000000, 17.000000)">
            <g id="Group-5">
              <g id="Icon/login" transform="translate(0.181107, 0.180890)">
                <path
                  d="M13.1864069,4.40927586 C13.1864069,6.84455172 11.213131,8.81927586 8.77568276,8.81927586 C6.34185517,8.81927586 4.36785517,6.84455172 4.36785517,4.40927586 C4.36785517,1.97472414 6.34185517,-1.687539e-14 8.77568276,-1.687539e-14 C11.213131,-1.687539e-14 13.1864069,1.97472414 13.1864069,4.40927586 Z"
                  id="Stroke-1"
                ></path>
                <path
                  d="M17.5545517,20.3806448 L17.5545517,16.3942655 C17.5531034,14.4883345 15.9925862,12.9321621 14.0873793,12.9343322 L3.45993103,12.9343322 C1.55544828,12.937231 -0.00144827586,14.5057138 0.00144827586,16.4101966 L-4.01456646e-13,20.3958517"
                  id="Stroke-3"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LoginIcon;
